module.exports = "/assets/img/ipallets/logo_pc.svg";